/* eslint-disable no-plusplus */
import React, { FC, useEffect, useState } from 'react'
// import cheerio from 'cheerio'
import { ProductByHandleQuery } from '../../../types/storefront'

interface Props {
  data?: ProductByHandleQuery['product']
  open: boolean
  onBack?: (value?: any) => any
}

const ProductSizeGuide: FC<Props> = ({ data, open, onBack }) => {
  const [tableData, setTableData] = useState()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [tabIndex, setTabIndex] = useState<number>(0)
  // 初始化dom事件，用最蠢的方法了
  function initDomEvent() {
    setTimeout(() => {
      // IN / CM change
      const tabDom = document.querySelectorAll('.sg-title-ctn li')
      const tableDom = document.querySelectorAll<HTMLDivElement>('.sizeBox')
      tabDom.forEach((item: any, index: number) => {
        item?.addEventListener('click', (e: any) => {
          e.stopPropagation()
          tabDom.forEach((item2: any) => {
            item2.classList.remove('title-active')
          })
          item.classList.add('title-active')
          setTabIndex(index)
          tableDom.forEach((item2: any) => {
            // eslint-disable-next-line no-param-reassign
            item2.style.display = 'none'
          })

          const dom = tableDom[index]
          if (dom) dom.style.display = 'block'
        })
      })
      // 折叠
      const measureArr = document.querySelectorAll('.measure-guide__header')
      measureArr.forEach((item: any) => {
        item?.addEventListener(
          'click',
          (e: any) => {
            e.stopPropagation()
            const measure = item.parentNode?.children[1]
            const icon = item.children[1]
            const isDisplay = measure?.classList.contains('displayNone')
            if (isDisplay) {
              measure?.classList.remove('displayNone')
              icon?.classList.add('iconfont-active')
            } else {
              measure?.classList.add('displayNone')
              icon?.classList.remove('iconfont-active')
            }
          },
          false
        )
      })
      // 尺寸切换
      const sizeBtn = document.querySelectorAll(
        '.common-sizemeasure__sizeChart-size span'
      )
      sizeBtn.forEach((item: any, index: number) => {
        item?.addEventListener('click', (e: any) => {
          e.stopPropagation()
          const nextParent = item.parentNode?.parentNode.children[2]
          const curParent = item.parentNode
          const curIndex = index % (sizeBtn.length / 2)
          for (let i = 0; i < curParent.children.length; i++) {
            curParent.children[i].classList.remove(
              'common-sizemeasure__sizeChart-sizeSelect'
            )
            nextParent.children[i].style.display = 'none'
          }
          curParent.children[curIndex].classList.add(
            'common-sizemeasure__sizeChart-sizeSelect'
          )
          nextParent.children[curIndex].style.display = 'block'
        })
      })
      // 返回
      const closeBtn = document.querySelectorAll('.closeSize')
      closeBtn.forEach((item) => {
        item.addEventListener('click', () => {
          onBack?.(false)
        })
      })
    }, 0)
  }
  useEffect(() => {
    async function initSizeGuideData() {
      if (!data) {
        return
      }
      const cheerio = (await import('cheerio')).default
      const $: any = cheerio.load(data?.descriptionHtml)
      setTableData($('.sizeChart-drawer__content').html())
      initDomEvent()
    }
    initSizeGuideData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, open])
  return tableData ? (
    <div
      className={`sizeguide-wrapper text-xs md:text-sm fixed w-full h-full overflow-x-auto top-0 bg-gray-100 transition-all ease-in-out duration-300 ${
        open ? 'right-0' : '-right-full'
      }`}
      style={{ zIndex: 1800 }}
    >
      {open && (
        <div
          className="table-wrapper w-fullbg-black"
          dangerouslySetInnerHTML={{ __html: tableData || '' }}
        />
      )}
    </div>
  ) : (
    <></>
  )
}

export default ProductSizeGuide
